import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import DeleteConfirmation from '../../components/delete-confirmation';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const DeletePostModal = ({ closeModal, deletePost, t }) =>
  <Modal onClose={closeModal}>
    <DeleteConfirmation
      title={t('delete-post-modal.delete-post')}
      message={t('delete-post-modal.will-detele-comments')}
      onConfirm={deletePost}
      onCancel={closeModal}
    />
  </Modal>;

DeletePostModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  deletePost: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      deletePost: () => closeModal(ownProps.postId),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(DeletePostModal));



// WEBPACK FOOTER //
// ./app/containers/delete-post-modal/delete-post-modal.js